const React = require('react');


module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT>rect ' + (props.className || '')}
    >
      <rect
        y="0.907227"
        width="1.28284"
        height="11.5456"
        transform="rotate(-45 0 0.907227)"
      />
      <rect
        x="8.16406"
        width="1.28284"
        height="11.5456"
        transform="rotate(45 8.16406 0)"
      />
    </svg>
  );
};
